// ============================================================================
// JAPANESE TRANSLATIONS - BIBLE FACTS
// ============================================================================
// 聖書についての魅力的な事実

export const bibleFacts = [
  {
    category: "構造",
    text: "聖書は約1500年の間に40人以上の異なる著者によって書かれた66巻から成っています",
    source: "正典聖書の構造"
  },
  {
    category: "規模",
    text: "聖書は原語で31,173節、1,189章、約783,137語を含んでいます",
    source: "聖書本文分析"
  },
  {
    category: "翻訳",
    text: "聖書は完全または部分的に3,000以上の言語に翻訳されており、世界で最も翻訳された本です",
    source: "世界聖書協会連盟"
  },
  {
    category: "聖句",
    text: "聖書で最も短い聖句は「イエスは涙を流された」（ヨハネ11:35）で、最も長いのはエステル8:9です",
    source: "聖書本文分析"
  },
  {
    category: "人気",
    text: "聖書は史上最も売れた本で、50億部以上が配布されています",
    source: "出版記録"
  },
  {
    category: "歴史",
    text: "1947年に発見された死海文書には、2,000年以上前の聖書写本が含まれています",
    source: "聖書考古学"
  },
  {
    category: "中心",
    text: "聖書の中心章は詩篇118篇で、中心節は詩篇118:8です",
    source: "聖書の数的構造"
  }
];

export default bibleFacts;
